import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { ShPageHeaderComponent, ShPaginationComponent, ShReportService, ShReportsModule } from '@stylehaven/components';

import { ReportService } from '../../entities';
import { DigihavenElementsModule } from '../elements/elements.module';
import { ColumnHandlerService } from '../record/services/column-handler.service';
import { RecordModule } from '../record/record.module';
import { ReportNaamCellComponent } from './components/cells/report-naam-cell/report-naam-cell.component';
import { ReportDetailContainerComponent } from './containers/report-detail-container/report-detail-container.component';
import { ReportsOverviewContainerComponent } from './containers/reports-overview-container/reports-overview-container.component';
import { ReportsRoutingModule } from './reports-routing.module';
import { ReportsSandboxService } from './sandbox/reports-sandbox.service';
import { ReportsColumnHandlerService } from './services/reports-column-handler.service';

@NgModule({
    declarations: [ReportsOverviewContainerComponent, ReportDetailContainerComponent, ReportNaamCellComponent],
    imports: [
        CommonModule,
        ReportsRoutingModule,
        ShReportsModule,
        TranslateModule,
        RouterModule,
        ShPageHeaderComponent,
        ShPaginationComponent,
        RecordModule,
        DigihavenElementsModule
    ],
    providers: [
        ReportsSandboxService,
        { provide: ShReportService, useClass: ReportService },
        { provide: ColumnHandlerService, useClass: ReportsColumnHandlerService }
    ]
})
export class ReportsModule {}
